import {
  CULTURALPRETEMEDITSUCCESS,
  CULTURALPRETEMEDITFAIL,
} from "../actionTypes";
const initialState = {
  editTemp: [],
};
const getculturePreBuiltTemplateEditReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CULTURALPRETEMEDITSUCCESS:
      return {
        ...state,
        editTemp: action.payload,
      };
    case CULTURALPRETEMEDITFAIL:
      return {
        ...state,
        editTemp: null,
      };
    default:
      break;
  }
  return state;
};
export default getculturePreBuiltTemplateEditReducer;
